import React, { useState, useEffect, useRef } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import "./inputDropdownSimple.scss";

const InputDropdownSimple = ({
    options = [],
    onSelect,
    value = "",
    placeholder = "Selecciona una opción",
    label = "Label",
    showLabel = true,
    required = false,
}) => {
    const [inputValue, setInputValue] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        if (value && typeof value === "object") {
            setInputValue(value.label || "");
        } else {
            setInputValue(value);
        }
    }, [value]);

    const handleInputClick = () => {
        setIsOpen((prevIsOpen) => !prevIsOpen);
    };

    const handleOptionClick = (option) => {
        setInputValue(option.label);
        onSelect(option);
        setIsOpen(false);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(event.target)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="input-dropdown-simple" ref={dropdownRef}>
            {showLabel && (
                <label className="input-dropdown-simple__label">
                    {label}
                    {required && (
                        <span className="input-dropdown-simple__required">
                            *
                        </span>
                    )}
                </label>
            )}
            <div className="input-dropdown-simple__wrapper">
                <input
                    type="text"
                    value={inputValue}
                    readOnly
                    onClick={handleInputClick}
                    placeholder={placeholder}
                    className={`input-dropdown-simple__input ${
                        isOpen ? "input-dropdown-simple__input--open" : ""
                    }`}
                    required={required}
                />
                <span className="input-dropdown-simple__icon">
                    {isOpen ? <FaChevronUp /> : <FaChevronDown />}
                </span>
            </div>
            {isOpen && options.length > 0 && (
                <ul
                    className="input-dropdown-simple__list"
                    onMouseDown={(e) => e.preventDefault()}
                >
                    {options.map((option, index) => (
                        <li
                            key={index}
                            className="input-dropdown-simple__list-item"
                            onClick={() => handleOptionClick(option)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default InputDropdownSimple;
